import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { trackDashboardCtaClicked } from "analytics";
import { PATHS } from "constants/pathConstants";
import { selectSpouseInformation } from "store/reducers/user/UserAccountSlice";
import NextMoveCard from ".";
import Translate from "translate/Translate";

const InviteSpouseNextMoveCard = () => {
  const history = useHistory();
  const spouseAccessCode = useSelector(selectSpouseInformation)
    ?.spouseAccessCode;

  if (!spouseAccessCode) {
    return null;
  }

  return (
    <NextMoveCard
      title={<Translate text="Invite your spouse" />}
      body={
        <Translate text="Good news! Your spouse is included in your membership. Share your spouse access code so they can activate their account." />
      }
      link={{
        onClick: () => {
          trackDashboardCtaClicked({
            workflow: "spouse_invite",
            ctaLocation: "next_move_card",
            ctaId: "invite_spouse"
          });
          history.push(PATHS.ACCOUNT_MANAGEMENT_PAYMENT_INFORMATION);
        },
        overrideClick: true,
        text: "Learn more",
        url: PATHS.ACCOUNT_MANAGEMENT_PAYMENT_INFORMATION
      }}
    />
  );
};

export default InviteSpouseNextMoveCard;
